import apolloClient from '@/store/apollo';

import CreateCommentGql from '@/store/graphql/mutations/CreatePageComment.gql';

export default {
    createComment: (id, comment) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateCommentGql,
                    variables: {
                        id: parseInt(id),
                        comment
                    }
                })
                .then(({ data }) => resolve(data.Comment))
                .catch(error => reject(error.message));
        })
};
